import { render, staticRenderFns } from "./role-widget.vue?vue&type=template&id=240faaea&scoped=true&"
import script from "./role-widget.vue?vue&type=script&lang=js&"
export * from "./role-widget.vue?vue&type=script&lang=js&"
import style0 from "./role-widget.vue?vue&type=style&index=0&id=240faaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240faaea",
  null
  
)

export default component.exports